module.exports = __webpack_public_path__ + "img/view-details.2d78c09f.svg";